// extracted by mini-css-extract-plugin
module.exports = {"warningBlock":"styles_warningBlock__maeBd","warningMessage":"styles_warningMessage__3e-Tz"};